/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LootshopCreditTransactionHistoryItem
 */
export interface LootshopCreditTransactionHistoryItem {
    /**
     * Transaction ID
     * @type {string}
     * @memberof LootshopCreditTransactionHistoryItem
     */
    id?: string;
    /**
     * Credit amount in USD
     * @type {number}
     * @memberof LootshopCreditTransactionHistoryItem
     */
    amount?: number;
    /**
     * Formatted USD amount (e.g., "$1.00")
     * @type {string}
     * @memberof LootshopCreditTransactionHistoryItem
     */
    amountFormatted?: string;
    /**
     * CREDIT = received, DEBIT = spent
     * @type {string}
     * @memberof LootshopCreditTransactionHistoryItem
     */
    type?: LootshopCreditTransactionHistoryItemTypeEnum;
    /**
     * Transaction subject/source
     * @type {string}
     * @memberof LootshopCreditTransactionHistoryItem
     */
    subject?: string;
    /**
     * Human-readable description
     * @type {string}
     * @memberof LootshopCreditTransactionHistoryItem
     */
    description?: string;
    /**
     * Transaction timestamp
     * @type {Date}
     * @memberof LootshopCreditTransactionHistoryItem
     */
    createdAt?: Date;
}


/**
 * @export
 */
export const LootshopCreditTransactionHistoryItemTypeEnum = {
    DEBIT: 'DEBIT',
    CREDIT: 'CREDIT'
} as const;
export type LootshopCreditTransactionHistoryItemTypeEnum = typeof LootshopCreditTransactionHistoryItemTypeEnum[keyof typeof LootshopCreditTransactionHistoryItemTypeEnum];


/**
 * Check if a given object implements the LootshopCreditTransactionHistoryItem interface.
 */
export function instanceOfLootshopCreditTransactionHistoryItem(value: object): value is LootshopCreditTransactionHistoryItem {
    return true;
}

export function LootshopCreditTransactionHistoryItemFromJSON(json: any): LootshopCreditTransactionHistoryItem {
    return LootshopCreditTransactionHistoryItemFromJSONTyped(json, false);
}

export function LootshopCreditTransactionHistoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootshopCreditTransactionHistoryItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'amountFormatted': json['amountFormatted'] == null ? undefined : json['amountFormatted'],
        'type': json['type'] == null ? undefined : json['type'],
        'subject': json['subject'] == null ? undefined : json['subject'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
    };
}

export function LootshopCreditTransactionHistoryItemToJSON(json: any): LootshopCreditTransactionHistoryItem {
    return LootshopCreditTransactionHistoryItemToJSONTyped(json, false);
}

export function LootshopCreditTransactionHistoryItemToJSONTyped(value?: LootshopCreditTransactionHistoryItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'amount': value['amount'],
        'amountFormatted': value['amountFormatted'],
        'type': value['type'],
        'subject': value['subject'],
        'description': value['description'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
    };
}

